// extracted by mini-css-extract-plugin
export default {"root":"fms2ZfVF9DSHMAFqiy4w","layout":"qAhakty0hBEQZ3B5LpfY","drawer":"xcra91UWNJbwobp5vaSG","content":"F8JKO8WDidzOHCL_boEY","sider":"hG4xJswK9s9LnwNz7a7t"};